"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ListView_module_css_1 = __importDefault(require("./ListView.module.css"));
/**
 * Displays children horizontally or vertically with even spacing
 */
function ListView({ children, direction }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: direction === "horizontal" ? ListView_module_css_1.default.horizontal : ListView_module_css_1.default.vertical, "data-testid": "listViewContainer", children: children }));
}
exports.ListView = ListView;
//# sourceMappingURL=index.js.map